import { getApiBaseUrl } from './apiBase';

function isHtmlCannotMethod(text) {
  if (!text) return false;
  const t = text.toLowerCase();
  return t.includes('<!doctype html') || t.includes('<html') || t.includes('cannot post') || t.includes('cannot put') || t.includes('cannot delete');
}

function getBasesForFallback() {
  const primary = getApiBaseUrl();
  return [primary];
}

function getToken() {
  try { return localStorage.getItem('token'); } catch { return null; }
}

export async function listPlans() {
  const bases = getBasesForFallback();
  let lastErr = null;
  for (const base of bases) {
    try {
      const res = await fetch(`${base}/plans`);
      if (res.ok) return res.json();
      const text = await res.text();
      if (isHtmlCannotMethod(text)) {
        lastErr = new Error(`Plans list not available at ${base}`);
        continue;
      }
      throw new Error(text || 'Failed to fetch plans');
    } catch (e) {
      lastErr = e;
      continue;
    }
  }
  throw lastErr || new Error('Failed to fetch plans');
}

export async function createPlan(data) {
  const token = getToken();
  const bases = getBasesForFallback();
  let lastErr = null;
  for (const base of bases) {
    try {
      const res = await fetch(`${base}/plans`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(data),
      });
      if (res.ok) return res.json();
      const text = await res.text();
      if (isHtmlCannotMethod(text)) {
        lastErr = new Error(`Cannot POST at ${base}/plans`);
        continue;
      }
      throw new Error(text || 'Failed to create plan');
    } catch (e) {
      lastErr = e;
      continue;
    }
  }
  throw lastErr || new Error('Failed to create plan');
}

export async function updatePlan(id, data) {
  const token = getToken();
  const bases = getBasesForFallback();
  let lastErr = null;
  for (const base of bases) {
    try {
      const res = await fetch(`${base}/plans/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(data),
      });
      if (res.ok) return res.json();
      const text = await res.text();
      if (isHtmlCannotMethod(text)) {
        lastErr = new Error(`Cannot PUT at ${base}/plans/${id}`);
        continue;
      }
      throw new Error(text || 'Failed to update plan');
    } catch (e) {
      lastErr = e;
      continue;
    }
  }
  throw lastErr || new Error('Failed to update plan');
}

export async function deletePlan(id) {
  const token = getToken();
  const bases = getBasesForFallback();
  let lastErr = null;
  for (const base of bases) {
    try {
      const res = await fetch(`${base}/plans/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        // Some servers may return 204 with no JSON.
        const ct = res.headers.get('content-type') || '';
        if (ct.includes('application/json')) return res.json();
        return { success: true };
      }
      const text = await res.text();
      if (isHtmlCannotMethod(text)) {
        lastErr = new Error(`Cannot DELETE at ${base}/plans/${id}`);
        continue;
      }
      throw new Error(text || 'Failed to delete plan');
    } catch (e) {
      lastErr = e;
      continue;
    }
  }
  throw lastErr || new Error('Failed to delete plan');
}